<template>
  <div class="CarouselItemsIndicator">
    <div v-for="item, index in items"
      :key="item._key"
      class="pip"
      :class="index === activeItemIndex && 'isActive'"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    activeItemIndex: Number,
  },
}
</script>

<style scoped>

.CarouselItemsIndicator {
  display: grid;
  grid-auto-flow: column;
  column-gap: 1.5%;
  justify-content: center;
}

.pip {
  width: var(--spacing-16);
  height: 0.375rem;
  background-color: var(--brand-color);
  opacity: 0.5;
  transition: opacity 0.15s;
}

.pip.isActive {
  opacity: 1;
}
</style>
